/**
 * Real-time synchronization types for WebSocket communication
 */
// Socket event names
export const SOCKET_EVENTS = {
    // Client-to-server
    JOIN_SUBMISSION: 'submission:join',
    LEAVE_SUBMISSION: 'submission:leave',
    FIELD_EDITING: 'submission:field_editing',
    JOIN_PRODUCT: 'product:join',
    LEAVE_PRODUCT: 'product:leave',
    JOIN_PDLC_BOARD: 'pdlc-board:join',
    LEAVE_PDLC_BOARD: 'pdlc-board:leave',
    // Server-to-client
    FIELD_CHANGE: 'submission:field_change',
    STATUS_CHANGE: 'submission:status_change',
    ASSIGNMENT_CHANGE: 'submission:assignment_change',
    PRESENCE_CHANGE: 'submission:presence_change',
    CONFLICT: 'submission:conflict',
    FILE_ADDED: 'submission:file_added',
    FILE_REMOVED: 'submission:file_removed',
    ASSET_CHANGE: 'submission:asset_change',
    JOIN_ACK: 'submission:join_ack',
    ASANA_CHANGED: 'product:asana_changed',
    /** A PDLC Board row changed or went stale. Payload: `PdlcBoardChangedEvent`. */
    PDLC_BOARD_CHANGED: 'pdlc-board:changed',
    // Activity feed
    ACTIVITY_NEW: 'activity:new',
    MENTION_NEW: 'mention:new',
    NOTIFICATION_NEW: 'notification:new',
    // Native messaging
    MESSAGE_NEW: 'message:new',
    MESSAGE_EDITED: 'message:edited',
    MESSAGE_DELETED: 'message:deleted',
    MESSAGE_REACTION: 'message:reaction',
    // Teams sidebar — a Graph change notification arrived for this user
    TEAMS_ACTIVITY: 'teams:activity',
    // The stack is about to restart for a deploy
    SYSTEM_MAINTENANCE: 'system:maintenance',
};
// Room naming convention
export function getSubmissionRoom(submissionId) {
    return `submission:${submissionId}`;
}
// Room naming convention for product-scoped events (e.g. Asana changes)
export function getProductRoom(productId) {
    return `product:${productId}`;
}
/** Per-entity activity room — every viewer of an entity joins this. */
export function getEntityRoom(entityType, entityId) {
    return `entity:${entityType}:${entityId}`;
}
/** Per-user notification room — every authenticated user is auto-joined. */
export function getUserRoom(userId) {
    return `user:${userId}`;
}
//# sourceMappingURL=sync.types.js.map